import * as React from 'react';
import { useAuth } from './context/AuthProvider';

export const usePermissions = () => {
  const { user, hasPermission, hasAccess } = useAuth();
  const isAuthenticated = !!user;
  const role = user?.role;

  const permissions = React.useMemo(() => {
    const can = (requiredRoles) => {
      if (!isAuthenticated) return false;
      return Array.isArray(requiredRoles) && requiredRoles.includes(role);
    };
    return {
      //* DATOS DE AUTENTICACIÓN
      user,
      isAuthenticated,
      role,
      
      //* ROLE ESPECÍFICOS
      isAdmin:   can(['ADMIN']),
      isHolder:  can(['HOLDER']),
      isSupport: can(['SUPPORT']),
      isUser:    can(['USER']),

      //* ACCIONES ESPECÍFICAS
      canCreate:    can(['ADMIN']),
      canEdit:      can(['ADMIN']),
      canDelete:    can(['ADMIN']),
      canDownload:  can(['ADMIN']),
      canExport:    can(['ADMIN', 'HOLDER']),
      canEditOwner: can(['ADMIN']),

      //* VISTAS ESPECÍFICAS
      canViewInventory: can(['ADMIN', 'HOLDER']),
      canViewPart:      can(['ADMIN', 'HOLDER']),
      canViewProperty:  can(['ADMIN', 'HOLDER']),
      canViewArea:      can(['ADMIN']),
      canViewBuilding:  can(['ADMIN']),
      canViewAsignSafe: can(['ADMIN']),
      canViewInfo:      can(['ADMIN', 'HOLDER', 'SUPPORT', 'USER']),

      //* UTILIDADES
      hasRole: (roles) => can(roles), //* VERIFICA SI TIENE ESE ROLE
      hasAccessRoute: (path) => isAuthenticated && hasAccess(path), //* VERIFICA SI TIENE ACCESO A ESA RUTA
    };
  }, [user, role, isAuthenticated, hasPermission, hasAccess]);

  return permissions;
};